import React from "react";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import "./privacyPolicy.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";

const Section = ({ number, title, children, featured = false }) => (
  <details
    className={`privacy-accordion ${
      featured ? "privacy-accordion--featured" : ""
    }`}
  >
    <summary>
      <div className="privacy-summary-left">
        <span className="privacy-number">
          {String(number).padStart(2, "0")}
        </span>

        <span className="privacy-summary-title">
          {title}
        </span>
      </div>

      <span className="privacy-chevron" aria-hidden="true">
        +
      </span>
    </summary>

    <div className="privacy-accordion-content">
      {children}
    </div>
  </details>
);

const BulletList = ({ items }) => (
  <ul className="privacy-list">
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
);

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <ProgressBarLoader />

      <Breadcrumbs
        title="Política de Privacidad"
        pagename="Política de Privacidad"
      />

      <main className="container py-5">

        {/* HERO */}
       

        <div className="privacy-updated">
              <span className="privacy-updated-dot"></span>

              Última actualización: 22 de septiembre de 2026
            </div>

        {/* INTRODUCTION */}
        <section className="privacy-notice">

          <div className="privacy-notice-icon">
            i
          </div>

          <div>
            <strong>
              Tu privacidad es importante para nosotros
            </strong>

            <p>
              SALINACRUCENSES BY GRUPO VIALA pone a tu disposición
              el presente Aviso de Privacidad para informarte de manera
              clara sobre el tratamiento de los datos personales que
              proporcionas al utilizar nuestros servicios.
            </p>
          </div>

        </section>

        {/* ACCORDIONS */}
        <section className="privacy-sections">

          {/* 01 */}
          <Section
            number={1}
            title="Responsable del tratamiento de tus datos personales"
            featured
          >

            <p>
              El responsable del tratamiento de tus datos personales es
              <strong> GRUPO VIALA</strong>, quien opera comercialmente
              bajo la marca <strong>SALINACRUCENSES</strong>.
            </p>

            <div className="privacy-company-card">

              <div className="privacy-company-header">

                <div className="privacy-company-logo">
                  GV
                </div>

                <div>
                  <h3>
                    SALINACRUCENSES BY GRUPO VIALA
                  </h3>

                  <span>
                    Responsable del tratamiento de datos personales
                  </span>
                </div>

              </div>

              <div className="privacy-company-data">

                <div>
                  <span>Razón social</span>

                  <strong>
                    GRUPO VIALA
                  </strong>
                </div>

                <div>
                  <span>RFC</span>

                  <strong>
                    GVI1202145L0
                  </strong>
                </div>

                <div>
                  <span>Marca comercial</span>

                  <strong>
                    SALINACRUCENSES
                  </strong>
                </div>

                <div>
                  <span>Domicilio</span>

                  <strong>
                    Calle Periférico, 308, Col. José Vasconcelos,
                    C.P. 68130, Oaxaca de Juárez, Oaxaca.
                  </strong>
                </div>

              </div>

            </div>

          </Section>

          {/* 02 */}
          <Section
            number={2}
            title="Medios de contacto"
          >

            <p>
              Para cualquier asunto relacionado con el tratamiento de
              datos personales, puedes comunicarte con nosotros a través
              del siguiente correo electrónico:
            </p>

            <div className="privacy-contact-card">

              <div className="privacy-contact-icon">
                @
              </div>

              <div>
                <span>
                  Correo para asuntos de privacidad
                </span>

                <strong>
                  hola@salinacrucenses.com
                </strong>
              </div>

            </div>

            <p>
              También podrás presentar solicitudes relacionadas con tus
              derechos de acceso, rectificación, cancelación u oposición
              (ARCO) a través de este mismo medio.
            </p>

          </Section>

          {/* 03 */}
          <Section
            number={3}
            title="Datos personales que recabamos"
            featured
          >

            <p>
              Dependiendo de la interacción que tengas con
              SALINACRUCENSES, podemos recabar los siguientes datos
              personales de identificación y contacto:
            </p>

            <div className="privacy-data-grid">

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  01
                </span>

                <strong>
                  Nombre completo
                </strong>

                <p>
                  Para identificar al usuario o pasajero.
                </p>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  02
                </span>

                <strong>
                  Teléfono
                </strong>

                <p>
                  Para contacto y atención relacionada con el servicio.
                </p>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  03
                </span>

                <strong>
                  Correo electrónico
                </strong>

                <p>
                  Para comunicaciones relacionadas con el servicio.
                </p>
              </div>

            </div>

            <div className="privacy-info-box">

              <strong>
                Datos personales sensibles
              </strong>

              <p>
                SALINACRUCENSES no solicita ni recaba de manera
                intencional datos personales sensibles para la prestación
                ordinaria de sus servicios.
              </p>

            </div>

          </Section>

          {/* 04 */}
          <Section
            number={4}
            title="Datos relacionados con la compra de boletos"
          >

            <p>
              Cuando realizas una compra de boleto a través de nuestros
              canales, podemos tratar la información necesaria para
              gestionar y prestar el servicio contratado.
            </p>

            <BulletList
              items={[
                "Nombre del pasajero.",
                "Teléfono.",
                "Correo electrónico.",
                "Origen del viaje.",
                "Destino del viaje.",
                "Fecha del viaje.",
                "Horario del viaje.",
                "Asiento seleccionado.",
                "Datos del comprador."
              ]}
            />

            <p>
              Estos datos son utilizados para gestionar la reservación,
              emitir el boleto, prestar el servicio, brindar atención al
              cliente y mantener los registros relacionados con la
              operación.
            </p>

          </Section>

          {/* 05 */}
          <Section
            number={5}
            title="Compra de boletos para menores de edad"
          >

            <p>
              Nuestro sitio web no solicita como requisito general la
              edad del pasajero durante el proceso de compra.
            </p>

            <p>
              Por lo tanto, un boleto puede ser adquirido para un menor
              de edad y, en ese caso, podremos tratar los datos que sean
              proporcionados para la prestación del servicio, como el
              nombre del pasajero y los datos de contacto relacionados
              con la compra.
            </p>

            <div className="privacy-info-box">

              <strong>
                Importante
              </strong>

              <p>
                Cuando una persona proporcione datos personales de un
                menor de edad, deberá contar con las facultades,
                autorizaciones o representación que resulten aplicables
                conforme a la legislación correspondiente.
              </p>

            </div>

          </Section>

          {/* 06 */}
          <Section
            number={6}
            title="Finalidades del tratamiento"
            featured
          >

            <p>
              Los datos personales que recabamos podrán ser utilizados
              para las siguientes finalidades necesarias para la
              prestación de nuestros servicios:
            </p>

            <h4 className="privacy-subtitle">
              Finalidades primarias
            </h4>

            <BulletList
              items={[
                "Identificar al comprador y/o pasajero.",
                "Procesar y administrar la compra de boletos.",
                "Generar y administrar reservaciones.",
                "Gestionar horarios, origen, destino y asiento.",
                "Brindar atención y seguimiento al usuario.",
                "Enviar información relacionada con el servicio contratado.",
                "Atender dudas, aclaraciones, quejas y solicitudes.",
                "Procesar solicitudes de facturación.",
                "Cumplir obligaciones legales y fiscales.",
                "Prevenir operaciones fraudulentas y proteger la seguridad de las transacciones.",
                "Atender requerimientos de autoridades competentes cuando legalmente corresponda."
              ]}
            />

            <h4 className="privacy-subtitle">
              Finalidades secundarias
            </h4>

            <BulletList
              items={[
                "Enviar promociones y ofertas de nuestros servicios.",
                "Realizar encuestas de satisfacción y calidad del servicio."
              ]}
            />

            <div className="privacy-marketing-box">

              <div className="privacy-marketing-icon">
                ✓
              </div>

              <div>

                <strong>
                  Comunicación promocional
                </strong>

                <p>
                  Actualmente no realizamos campañas promocionales de
                  manera general. En caso de implementar comunicaciones
                  comerciales, podrán realizarse mediante los canales de
                  contacto proporcionados, incluyendo WhatsApp, conforme
                  a las opciones y mecanismos de oposición disponibles.
                </p>

              </div>

            </div>

          </Section>

          {/* 07 */}
          <Section
            number={7}
            title="Pagos y datos bancarios"
          >

            <p>
              Para las compras realizadas a través de nuestra plataforma
              en línea utilizamos <strong>Openpay</strong> como proveedor
              de servicios de pago.
            </p>

            <p>
              SALINACRUCENSES no solicita ni almacena directamente números
              completos de tarjetas, códigos de seguridad (CVV), fechas
              de vencimiento u otros datos completos de tarjetas bancarias
              para procesar los pagos.
            </p>

            <div className="privacy-provider-grid">

              <div className="privacy-provider-card">

                <span className="privacy-provider-tag">
                  PAGOS EN LÍNEA
                </span>

                <h4>
                  Openpay
                </h4>

                <p>
                  El procesamiento de la información necesaria para la
                  operación del pago se realiza a través del proveedor de
                  servicios de pago correspondiente.
                </p>

              </div>

              <div className="privacy-provider-card">

                <span className="privacy-provider-tag">
                  PAGOS PRESENCIALES
                </span>

                <h4>
                  BBVA
                </h4>

                <p>
                  En operaciones realizadas físicamente, las terminales
                  bancarias son operadas por BBVA y el tratamiento de la
                  información bancaria se encuentra sujeto a las políticas
                  y condiciones aplicables de dicho proveedor.
                </p>

              </div>

            </div>

            <p>
              Los datos bancarios y de tarjeta son tratados por los
              proveedores correspondientes conforme a sus propias
              políticas de privacidad y a las disposiciones legales
              aplicables.
            </p>

          </Section>

          {/* 08 */}
          <Section
            number={8}
            title="Facturación"
          >

            <p>
              Para la generación de comprobantes fiscales, utilizamos
              <strong> Factura.com</strong> como plataforma de facturación.
            </p>

            <p>
              Cuando solicites una factura, podrán ser tratados los
              siguientes datos fiscales:
            </p>

            <div className="privacy-data-grid">

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  01
                </span>

                <strong>
                  RFC
                </strong>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  02
                </span>

                <strong>
                  Nombre o razón social
                </strong>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  03
                </span>

                <strong>
                  Código postal fiscal
                </strong>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  04
                </span>

                <strong>
                  Régimen fiscal
                </strong>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  05
                </span>

                <strong>
                  Uso de CFDI
                </strong>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  06
                </span>

                <strong>
                  Correo electrónico
                </strong>
              </div>

              <div className="privacy-data-card">
                <span className="privacy-data-number">
                  07
                </span>

                <strong>
                  Domicilio fiscal
                </strong>
              </div>

            </div>

            <p>
              Los datos fiscales serán utilizados para la elaboración y
              entrega de los comprobantes fiscales correspondientes y para
              el cumplimiento de las obligaciones fiscales aplicables.
            </p>

          </Section>

          {/* 09 */}
          <Section
            number={9}
            title="Datos proporcionados mediante WhatsApp"
          >

            <p>
              Cuando te comuniques con SALINACRUCENSES mediante WhatsApp,
              podremos recibir y tratar los datos que voluntariamente
              proporciones para atender tu solicitud.
            </p>

            <BulletList
              items={[
                "Nombre.",
                "Número de boleto.",
                "Teléfono.",
                "Datos relacionados con el viaje.",
                "Comprobantes.",
                "Identificación.",
                "Datos fiscales."
              ]}
            />

            <div className="privacy-warning-box">

              <span className="privacy-warning-icon">
                !
              </span>

              <div>

                <strong>
                  Recomendación de seguridad
                </strong>

                <p>
                  Te recomendamos no enviar por medios de mensajería
                  información que no sea necesaria para resolver tu
                  solicitud.
                </p>

              </div>

            </div>

          </Section>

          {/* 10 */}
          <Section
            number={10}
            title="Videovigilancia"
          >

            <p>
              Contamos con sistemas de videovigilancia en determinadas
              taquillas e instalaciones y en algunas unidades de
              transporte.
            </p>

            <div className="privacy-camera-card">

              <div className="privacy-camera-icon">
                CAM
              </div>

              <div>

                <span>
                  PERIODO DE CONSERVACIÓN
                </span>

                <strong>
                  5 días
                </strong>

                <p>
                  Las grabaciones podrán conservarse durante un periodo
                  aproximado de cinco días, salvo que resulte necesario
                  conservarlas por un periodo diferente debido a una
                  obligación legal, investigación, incidente o solicitud
                  de autoridad competente.
                </p>

              </div>

            </div>

            <p>
              Las imágenes obtenidas mediante los sistemas de
              videovigilancia podrán utilizarse principalmente para fines
              de seguridad, protección de personas, bienes e instalaciones
              y atención de incidentes.
            </p>

          </Section>

          {/* 11 */}
          <Section
            number={11}
            title="Transferencia y comunicación de datos personales"
            featured
          >

            <p>
              Para la prestación de nuestros servicios y el cumplimiento
              de nuestras obligaciones, algunos datos personales podrán
              ser comunicados o puestos a disposición de terceros,
              proveedores o autoridades, según corresponda.
            </p>

            <div className="privacy-transfer-grid">

              <div className="privacy-transfer-card">
                <strong>
                  Openpay
                </strong>

                <p>
                  Procesamiento de pagos realizados mediante la plataforma
                  en línea.
                </p>
              </div>

              <div className="privacy-transfer-card">
                <strong>
                  Bancos y procesadores de pago
                </strong>

                <p>
                  Procesamiento y operación de transacciones realizadas
                  mediante medios de pago.
                </p>
              </div>

              <div className="privacy-transfer-card">
                <strong>
                  Factura.com
                </strong>

                <p>
                  Procesamiento de información necesaria para la emisión
                  de comprobantes fiscales.
                </p>
              </div>

              <div className="privacy-transfer-card">
                <strong>
                  Proveedor de hosting
                </strong>

                <p>
                  Operación, alojamiento y funcionamiento de los sistemas
                  tecnológicos utilizados por nuestros servicios.
                </p>
              </div>

              <div className="privacy-transfer-card">
                <strong>
                  Autoridades competentes
                </strong>

                <p>
                  Cuando exista una obligación legal o requerimiento de
                  autoridad competente.
                </p>
              </div>

              <div className="privacy-transfer-card">
                <strong>
                  GRUPO VIALA
                </strong>

                <p>
                  Tratamiento necesario para la administración y operación
                  de los servicios de la empresa responsable.
                </p>
              </div>

            </div>

            <div className="privacy-info-box">

              <strong>
                Tratamiento por proveedores
              </strong>

              <p>
                Cuando intervengan proveedores que traten datos personales
                por cuenta de GRUPO VIALA, éstos deberán sujetarse a las
                obligaciones de confidencialidad y protección aplicables
                al servicio contratado.
              </p>

            </div>

          </Section>

          {/* 12 */}
          <Section
            number={12}
            title="Derechos ARCO"
            featured
          >

            <p>
              Como titular de tus datos personales, puedes ejercer los
              derechos de:
            </p>

            <div className="privacy-arco-grid">

              <div>
                <span>
                  A
                </span>

                <strong>
                  Acceso
                </strong>

                <p>
                  Conocer qué datos personales tenemos y cómo los
                  utilizamos.
                </p>
              </div>

              <div>
                <span>
                  R
                </span>

                <strong>
                  Rectificación
                </strong>

                <p>
                  Solicitar la corrección de datos inexactos o
                  desactualizados.
                </p>
              </div>

              <div>
                <span>
                  C
                </span>

                <strong>
                  Cancelación
                </strong>

                <p>
                  Solicitar la eliminación de tus datos cuando resulte
                  procedente.
                </p>
              </div>

              <div>
                <span>
                  O
                </span>

                <strong>
                  Oposición
                </strong>

                <p>
                  Oponerte a determinados tratamientos de tus datos.
                </p>
              </div>

            </div>

            <p>
              Para ejercer cualquiera de estos derechos, deberás enviar
              una solicitud al correo:
            </p>

            <div className="privacy-email-highlight">
              hola@salinacrucenses.com
            </div>

          </Section>

          {/* 13 */}
          <Section
            number={13}
            title="Procedimiento para ejercer los Derechos ARCO"
          >

            <p>
              La solicitud deberá indicar, al menos:
            </p>

            <BulletList
              items={[
                "Nombre del titular.",
                "Medio para recibir notificaciones.",
                "Documento que acredite la identidad del titular o, en su caso, la representación legal.",
                "Descripción clara y precisa de los datos personales respecto de los cuales se solicita ejercer el derecho.",
                "Derecho ARCO que se pretende ejercer.",
                "Cualquier elemento que facilite la localización de los datos personales."
              ]}
            />

            <p>
              Una vez recibida la solicitud, podremos solicitar información
              adicional cuando resulte necesaria para acreditar la identidad
              o atender correctamente la petición.
            </p>

            <div className="privacy-timeline">

              <div className="privacy-timeline-item">

                <span>
                  01
                </span>

                <div>
                  <strong>
                    Recepción
                  </strong>

                  <p>
                    Recibimos y revisamos tu solicitud.
                  </p>
                </div>

              </div>

              <div className="privacy-timeline-item">

                <span>
                  02
                </span>

                <div>
                  <strong>
                    Evaluación
                  </strong>

                  <p>
                    Verificamos la identidad y la información necesaria.
                  </p>
                </div>

              </div>

              <div className="privacy-timeline-item">

                <span>
                  03
                </span>

                <div>
                  <strong>
                    Respuesta
                  </strong>

                  <p>
                    La solicitud será atendida dentro de los plazos
                    establecidos por la legislación aplicable.
                  </p>
                </div>

              </div>

            </div>

          </Section>

          {/* 14 */}
          <Section
            number={14}
            title="Limitación del uso o divulgación de los datos"
          >

            <p>
              Puedes solicitar la limitación del uso o divulgación de tus
              datos personales mediante una solicitud enviada al correo:
            </p>

            <div className="privacy-email-highlight">
              hola@salinacrucenses.com
            </div>

            <p>
              En la solicitud deberás indicar de manera clara el uso o
              divulgación respecto del cual deseas establecer una
              limitación.
            </p>

          </Section>

          {/* 15 */}
          <Section
            number={15}
            title="Promociones y comunicaciones comerciales"
          >

            <p>
              Actualmente no realizamos campañas comerciales de manera
              general mediante nuestros canales de contacto.
            </p>

            <p>
              En el futuro podremos utilizar los datos de contacto
              proporcionados para enviar promociones, ofertas o realizar
              encuestas de satisfacción relacionadas con nuestros
              servicios.
            </p>

            <div className="privacy-marketing-box">

              <div className="privacy-marketing-icon">
                ✓
              </div>

              <div>

                <strong>
                  Tú decides
                </strong>

                <p>
                  Podrás manifestar tu oposición a recibir comunicaciones
                  promocionales utilizando los mecanismos que se pongan a
                  disposición en dichas comunicaciones o contactándonos
                  directamente.
                </p>

              </div>

            </div>

          </Section>

          {/* 16 */}
          <Section
            number={16}
            title="Cookies y tecnologías de navegación"
          >

            <p>
              Nuestro sitio puede utilizar tecnologías necesarias para
              permitir su correcto funcionamiento y mejorar la experiencia
              de navegación.
            </p>

            <p>
              Actualmente no utilizamos sistemas externos de analítica o
              herramientas de seguimiento con fines estadísticos o
              publicitarios.
            </p>

            <p>
              Las configuraciones disponibles en el navegador del usuario
              pueden permitir bloquear o limitar determinadas tecnologías
              de almacenamiento o navegación.
            </p>

          </Section>

          {/* 17 */}
          <Section
            number={17}
            title="Seguridad de los datos personales"
          >

            <p>
              GRUPO VIALA adopta medidas administrativas, técnicas y
              físicas razonables orientadas a proteger los datos personales
              contra daño, pérdida, alteración, destrucción o acceso,
              tratamiento o divulgación no autorizados.
            </p>

            <p>
              El nivel de protección podrá variar dependiendo de la
              naturaleza de la información y de los riesgos asociados al
              tratamiento correspondiente.
            </p>

          </Section>

          {/* 18 */}
          <Section
            number={18}
            title="Conservación de los datos personales"
          >

            <p>
              Los datos personales serán conservados durante el tiempo que
              resulte necesario para cumplir las finalidades descritas en
              este Aviso de Privacidad y las obligaciones legales,
              contractuales, fiscales o administrativas aplicables.
            </p>

            <p>
              Una vez que los datos ya no sean necesarios, se implementarán
              las medidas correspondientes para su eliminación, bloqueo o
              conservación cuando exista una obligación legal que así lo
              requiera.
            </p>

            <div className="privacy-info-box">

              <strong>
                Videograbaciones
              </strong>

              <p>
                Las grabaciones de videovigilancia tienen un periodo
                ordinario de conservación de aproximadamente cinco días,
                sujeto a las excepciones señaladas en este aviso.
              </p>

            </div>

          </Section>

          {/* 19 */}
          <Section
            number={19}
            title="Sitios y servicios de terceros"
          >

            <p>
              Nuestro sitio y nuestros servicios pueden interactuar con
              plataformas o proveedores externos necesarios para realizar
              determinadas operaciones.
            </p>

            <p>
              Entre ellos pueden encontrarse proveedores de pagos,
              facturación, servicios bancarios, infraestructura tecnológica
              y otros servicios necesarios para la operación.
            </p>

            <p>
              El tratamiento que dichos terceros realicen sobre los datos
              personales que se encuentren bajo su responsabilidad se regirá
              por sus respectivos avisos y políticas de privacidad.
            </p>

          </Section>

          {/* 20 */}
          <Section
            number={20}
            title="Cambios al Aviso de Privacidad"
          >

            <p>
              GRUPO VIALA podrá modificar o actualizar el presente Aviso
              de Privacidad cuando resulte necesario debido a cambios
              legales, regulatorios, operativos, tecnológicos o en los
              servicios ofrecidos.
            </p>

            <p>
              La versión vigente será publicada en el sitio web de
              SALINACRUCENSES y señalará la fecha de su última
              actualización.
            </p>

          </Section>

          {/* 21 */}
          <Section
            number={21}
            title="Legislación aplicable"
          >

            <p>
              El tratamiento de los datos personales se realizará conforme
              a la legislación mexicana aplicable en materia de protección
              de datos personales en posesión de los particulares.
            </p>

            <p>
              Este Aviso de Privacidad se emite considerando la
              <strong>
                {" "}
                Ley Federal de Protección de Datos Personales en Posesión
                de los Particulares
              </strong>
              y demás disposiciones aplicables.
            </p>

          </Section>

          {/* 22 */}
          <Section
            number={22}
            title="Aceptación y puesta a disposición"
          >

            <div className="privacy-acceptance-box">

              <span className="privacy-acceptance-check">
                ✓
              </span>

              <div>

                <strong>
                  Aviso de Privacidad
                </strong>

                <p>
                  Al proporcionar tus datos personales a
                  SALINACRUCENSES BY GRUPO VIALA, reconoces haber tenido
                  acceso al presente Aviso de Privacidad y conocer las
                  condiciones aplicables al tratamiento de tus datos
                  personales.
                </p>

              </div>

            </div>

            <p>
              La puesta a disposición de este Aviso de Privacidad tiene
              como finalidad permitir que conozcas las características
              principales del tratamiento de tus datos personales antes o
              al momento de proporcionarlos, según corresponda.
            </p>

          </Section>

        </section>

        {/* FOOTER */}
        <section className="privacy-footer-card">

          <div>

            <span className="privacy-footer-label">
              SALINACRUCENSES BY GRUPO VIALA
            </span>

            <h2>
              Tu información merece ser protegida.
            </h2>

            <p>
              Si tienes alguna duda relacionada con el tratamiento de tus
              datos personales, puedes comunicarte con nosotros.
            </p>

          </div>

          <a
            href="mailto:hola@salinacrucenses.com"
            className="privacy-contact-button"
          >
            Contactar
            <span>→</span>
          </a>

        </section>

       

      </main>
    </div>
  );
};

export default PrivacyPolicy;